import { SearchDriverOptions } from '@elastic/search-ui';
import MyAPIConnector from '../connector/CustomConnector';

const connector = new MyAPIConnector();

let parameters : URLSearchParams;

const serializeFilters = (filters: any[]): string =>
  filters
    .map((filter) => `${encodeURIComponent(filter.field)}:${encodeURIComponent(filter.values.join(","))}`)
    .join(";");

const deserializeFilters = (filtersString: string): any[] =>
  filtersString
    .split(";")
    .filter(Boolean)
    .map((filter) => {
      const [field, values] = filter.split(":");
      return {
        field: decodeURIComponent(field),
        values: decodeURIComponent(values).split(",")
      };
    });

const routingOptions = {
  readUrl: (): string => {
    parameters = new URLSearchParams(window.location.search);

    return window.location.search;
  },
  writeUrl: (url: string, { replaceUrl }: { replaceUrl: boolean }): void => {
    const urlSearchParams = new URLSearchParams(url);

    const mergedParams = {
      ...Object.fromEntries(urlSearchParams.entries()),
      ...Object.fromEntries(parameters.entries())
    };

    const filtersString = urlSearchParams.get("filters") || "";
    const filters = filtersString ? deserializeFilters(filtersString) : [];
    if (filters.length !== 0) {
      mergedParams.filters = serializeFilters(filters);
    }

    const queryString = urlSearchParams.get("q") || "";
    const query = queryString ? encodeURIComponent(queryString) : "";
    if (query.length !== 0) {
      mergedParams.q = decodeURIComponent(query);
    }

    const newUrl = `${window.location.pathname}?${new URLSearchParams(mergedParams).toString()}`;

    if (replaceUrl) {
      window.history.replaceState(null, "", newUrl);
    } else {
      window.history.pushState(null, "", newUrl);
    }
  },
};

const config: SearchDriverOptions = {
  alwaysSearchOnInitialLoad: true,
  apiConnector: connector,
  hasA11yNotifications: true,
  initialState: {
    resultsPerPage: 10,
  },
  searchQuery: {
    result_fields: {      
      name: {
        raw: {},
      },
      cf_brand: {
        raw: {}
      },
      company_name: {
        raw: {},
      },
      cf_department: {
        raw: {},
      },
      location_city: {
        raw: {},
      },
      type_of_employment_label: {
        raw: {},
      },
      location_geopoint: {
        raw: {},
      },
      posting_url: {
        raw: {}
      }
    },
    search_fields: {
      name: {},
      cf_department: {},
      cf_brand: {}      
    },
    disjunctiveFacets: [
      'cf_department',
      'cf_brand',
      'cf_category',
      'location_city',
    ],
    facets: {      
      cf_department: {
        type: 'value',
        size: 100
      },
      cf_brand: {
        type: 'value',
        size: 100
      },
      cf_category: {
        type: 'value',
        size: 100
      },
      location_city: {
        type: 'value',
        size: 500        
      },
      search_radius: {
        type: 'value',
      },
      search_location: {
        type: 'value',
      },
    },
  },
  routingOptions: routingOptions,
};

export default config;
